import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    modalUrl: String,
    isBlocked: Boolean
  }

  handleClick(event) {
    // Don't open modal if clicking on a booking or blocked time slot
    // Bookings are links with data-turbo-frame="modal"
    // Blocked time slots are also links
    const clickedElement = event.target
    const linkElement = clickedElement.closest('a')

    // If clicked on a booking or blocked time slot link, let it handle the click
    if (linkElement) {
      // Don't prevent default, let the link handle navigation
      return
    }

    // Don't open modal if this hour is blocked
    if (this.isBlockedValue) {
      return
    }

    // Check if user just finished dragging (drag & scroll)
    // Look for scroll containers that might be dragging, starting from document root
    const calendarScroll = document.querySelector('[data-agenda-target="calendarScroll"]')
    const headerScroll = document.querySelector('[data-agenda-target="headerScroll"]')

    // Check if either scroll container is currently being dragged
    if ((calendarScroll && calendarScroll.dataset.isDragging === 'true') ||
      (headerScroll && headerScroll.dataset.isDragging === 'true')) {
      return
    }

    if (this.modalUrlValue) {
      event.preventDefault()
      const isNativeApp = document.documentElement.dataset.hotwireNative === "true"
      const frame = isNativeApp ? "_top" : "modal"
      Turbo.visit(this.modalUrlValue, { frame })
    }
  }
}
